import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { GetLogFilesInput, GetLogFiles, GetLogFilesVariables } from '../../types'
import { GET_LOG_FILES } from './operations'

interface Props {
  filter: GetLogFilesInput
}

export const useGetLogFiles = ({ filter }: Props) => {
  const { lab, date, gmt } = filter || {}
  const queryVariables = useMemo<GetLogFilesVariables>(
    () => ({
      filterData: {
        date,
        lab,
        gmt,
      },
    }),
    [date, lab]
  )
  const logs = useQuery<GetLogFiles, GetLogFilesVariables>(GET_LOG_FILES, {
    variables: queryVariables,
  })

  return logs
}
